import { render, staticRenderFns } from "./ListBrokers.vue?vue&type=template&id=09684b44&scoped=true"
import script from "./ListBrokers.vue?vue&type=script&lang=js"
export * from "./ListBrokers.vue?vue&type=script&lang=js"
import style0 from "./ListBrokers.vue?vue&type=style&index=0&id=09684b44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09684b44",
  null
  
)

export default component.exports
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerHourglass,QBtn,QTooltip,QMenu,QItemSection,QList,QSeparator,QItem,QItemLabel});qInstall(component, 'directives', {ClosePopup});
